import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { kebabCase } from 'lodash';
import Button from '../layouts/Button';
import BoxedContainer from '../layouts/BoxedContainer';

export default function BannerCta({ data }) {
  const { title, text, image, link } = data;
  return (
    <section className="bg-white lg:pb-[140px] pb-[70px]">
      <BoxedContainer className="regular">
        <div
          className="w-full 2xl:h-[380px] h-[100%] bg-white relative
        before:!inline before:content-[''] before:absolute before:top-0 before:w-full
        before:h-full before:bg-black before:bg-opacity-60 before:z-10"
        >
          {image && (
            <LazyLoadImage
              src={image.url}
              alt={title}
              className="w-full h-full object-cover absolute z-5"
            />
          )}
          <div
            className="w-full h-full flex flex-col justify-center lg:pt-[80px]
            pt-[50px] lg:pb-[88px] pb-[50px] lg:px-[200px] md:px-[100px] px-[15px] relative z-10"
          >
            <h3
              className="md:text-[25px] text-[33px] text-white 2xl:leading-[23px] lg:leading-[44px]
              leading-[42px] font-roboto-condensed-bold uppercase"
            >
              {title}
            </h3>
            <p
              className="2xl:text-base text-[14px] text-white 2xl:leading-[23px] leading-6
              font-roboto-regular lg:mt-[34px] mt-[20px]"
            >
              {text}
            </p>
            {link && (
              <Button
                url={link.url}
                label={link.name}
                ariaLabel={link.name}
                tagName={kebabCase(link.name)}
                variant="primaryWhite"
                text="w-[202px] min-w-[min-content] h-[42px] px-[37px] whitespace-pre lg:mt-[42px]
                mt-[45px] !bg-white hover:!bg-black"
              />
            )}
          </div>
        </div>
      </BoxedContainer>
    </section>
  );
}
